class BellaPremiumMenu extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const signal = this.abort.signal;
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-bella-menu-open]');
      if (!trigger || trigger.getAttribute('aria-controls') !== this.dialog.id) return;
      event.preventDefault();
      if (this.dialog.open) return;
      this.launcher = trigger;
      this.previousOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      trigger.setAttribute('aria-expanded', 'true');
      this.dialog.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
    }, {signal});
    this.dialog.addEventListener('click', event => {
      if (event.target.closest('[data-bella-close]') || event.target === this.dialog) this.dialog.close();
    }, {signal});
    this.dialog.addEventListener('close', () => {
      document.body.style.overflow = this.previousOverflow ?? '';
      this.launcher?.setAttribute('aria-expanded', 'false');
      this.launcher?.focus();
    }, {signal});
  }
  disconnectedCallback() {
    if (this.dialog?.open) document.body.style.overflow = this.previousOverflow ?? '';
    this.abort?.abort();
  }
}
if (!customElements.get('bella-premium-menu')) customElements.define('bella-premium-menu', BellaPremiumMenu);